import React, { Component,useRef } from 'react'
import { MapContainer, TileLayer, ZoomControl, Marker, Popup, GeoJSON, MapConsumer, useMap} from 'react-leaflet'
import { Icon } from 'leaflet'
import axios from 'axios'
import { useMobileOrientation, CustomView, isTablet, isDesktop, isMobile, isMobileOnly } from 'react-device-detect'
import { Grid } from 'react-loader-spinner'

import './css/map.scss'

import TypeButton from './components/TypeButton'
import GenreButton from './components/GenreButton'
import TrendButton from './components/TrendButton'
import {replaceDateToString, ContentsView} from './components/ContentsView'
import { load5gDataJson, Contents } from './components/ContentClass'

import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'

import geoJsonData from './japan-lightweight.geojson'
import marker_5g from './images/pin-5g.png'
import marker_l5g from './images/pin-l5g.png'
import marker_lab from './images/pin-lab.png'
import marker_shadow from './images/pin-shadow.png'

const BASE_FILL_COLOR = '#dde4ee'

let ContentClass = new Contents()
let MapObj = null
var MarkerObj = []
var bsRef = null

const genres = ['農業', '漁業', '工場', '林業', '建設', '交通', '防災', '防犯', '防災・減災', '働き方', '発電所', 'モビリティ', 'インフラ', '空港・港湾', '鉄道・道路', '観光・eスポーツ', '医療・ヘルスケア', 'スマートシティ', '文化・スポーツ', '放送', '工場・発電所等', '河川', '道路', '鉄道', 'その他']
let genreStatus = new Object()

// function MyComponent() {
//     const map = useMapEvents({
//       click: () => {
//         map.locate()
//       },
//       locationfound: (location) => {
//         console.log('location found:', location)
//       },
//     })
//     return null
// }

/**
 * URLからパラメーターを取得
 * 
 * @return {array} o - パラメーター
 */
 function getUrlParam(url) {
    var q = (url) ? url.split("?") : location.search.split("?")
    var a,
        i,
        s,
        o = {}
    if (q.length > 1) {
        q = q[1]
        a = q.split("&")
        for (i = 0 ; i < a.length ; i++) {
            s = a[i].split("=")
            s[0] = s[0].replace("%5B%5D", "")
            s[0] = s[0].replace("[]", "")
            if (!o[s[0]]) {
                o[s[0]] = [s[1]]
            } else {
                o[s[0]].push(s[1])
            }
        }
    }
    return o
}

export default class Map extends Component {

    constructor(props) {
        super(props)
        this.style = this.style.bind(this)
        this.typeBtn = React.createRef()
        this.genreBtn = React.createRef()
        this.trendBtn = React.createRef()
        this.bottomSheetRef = React.createRef()
        this.state = {
            prefecture: [],
            wholeDatas:[],
            markerDatas: [],
            recentDatas: [],
            selectedData: [],
            trendDatas: [],
            activeType: '',
            activeGenre: [],
            typeGenreFrameView: false,
            recentInfoView: false,
            infoFrameView: false,
            bottomSheetView: false,
            setbottomSheetView: false,
            loaderStyle: {},
            publishedDate: '',
            infoHeaderResult: '',
            infoHeaderNum: 0
        }
        this.viewInfoFrame = this.viewInfoFrame.bind(this)
        this.viewRecentInfoFrame = this.viewRecentInfoFrame.bind(this)
        this.recentInfoClickHandler = this.recentInfoClickHandler.bind(this)
        this.viewRecentInfoOnMap = this.viewRecentInfoOnMap.bind(this)
        this.searchBtnClickHandler = this.searchBtnClickHandler.bind(this)
        this.searchByKeyword = this.searchByKeyword.bind(this)
        this.viewMarkerOnMap = this.viewMarkerOnMap.bind(this)

    }
    style(feature) {
        return {
            fillColor: BASE_FILL_COLOR,
            weight: 3,
            opacity: 1,
            color: '#c8cacd',
            dashArray: '3',
            fillOpacity: 0.6
        }
    }

    componentDidMount() {
        let isPreview = false
        if (typeof getUrlParam().mode !== 'undefined') {
            isPreview = (getUrlParam().mode[0] === 'preview') ? true : false
        }

        bsRef = this.bottomSheetRef

        load5gDataJson(isPreview, 'data')
        .then(response => {
            const {wholeDatas, markerDatas, recentDatas} = this.state
            let {publishedDate} = this.state

            const recentDate = response[0].publishedDate
            response.forEach(element => {
                wholeDatas.push(element)
                markerDatas.push(element)
                if (element.publishedDate.getTime() === recentDate.getTime()) {
                    recentDatas.push(element)
                }
            })

            publishedDate = `${replaceDateToString(this.state.wholeDatas[0].publishedDate)} ${this.state.recentDatas.length}件追加`
            ContentClass.datas = markerDatas
            // remove marker
            MapObj.eachLayer(function(layer){
                if (typeof layer.options.icon !== 'undefined') {
                    MapObj.removeLayer(layer)
                }
            })
            this.setState({ wholeDatas })
            this.setState({ markerDatas })
            this.setState({ recentDatas })
            this.setState({ publishedDate })
            this.setState({loaderStyle: {opacity: 0}})
            this.setState({ recentInfoView: true })
            this.setState({ typeGenreFrameView: true })

            if (typeof getUrlParam().cid !== 'undefined') {
                getUrlParam().cid.forEach(uid => {
                    const target = ContentClass.lookupByUid(uid)
                    if (target.datas.length > 0) {
                        this.viewInfoByUid(target)
                    }
                })
            } else if (typeof getUrlParam().kw !== 'undefined') {
                getUrlParam().kw.forEach(kw => {
                    // let keywords = 'エリア　-自動 "End to End"'
                    this.searchByKeyword(kw)
                })
            }
        })

        load5gDataJson(isPreview, 'trend')
        .then(response => {
            const {trendDatas} = this.state

            response.forEach(element => {
                trendDatas.push(element)
            })
            
            this.setState({ trendDatas })
        })
    }

    bindMarker = (ref) => {
        if (ref) {
            if (MarkerObj.filter(n => n.options.data === ref.options.data).length === 0 && ref._popup) {
                MarkerObj.push(ref)
                if (this.state.infoFrameView && MarkerObj.length === 1) {
                    this.viewMarkerOnMap(MarkerObj[0].options.data)
                }
            }
        }
    }

    modifyGenreBtnStatus(genreBtn) {
        if (genreStatus) {
            Object.keys(genreStatus).map((key) => {
                genreBtn.setState((state) => {
                    return {[key]: genreStatus[key]}
                })
            })
        }
    }

    viewInfoFrame(e) {
        this.setState({ infoFrameView: e })
        this.setState({ typeGenreFrameView: !e})
        const infoFrame = document.getElementsByClassName('infoFrame')[0]
        infoFrame.scrollTop = 0

        if (this.state.selectedData.length === 1) {
            const viewDatas = Array.prototype.slice.call(document.getElementsByClassName('contentsView'))
            const index = viewDatas.findIndex((n) => n.dataset.id === this.state.selectedData[0].uid);
            console.log({index})
            infoFrame.scrollTop = viewDatas[index].offsetTop - 44
        }

        const container = document.getElementsByClassName('leaflet-container')[0]
        if (e) {
            container.classList.add('leaflet-viewInfo-sp')
        } else {
            container.classList.remove('leaflet-viewInfo-sp')
        }
        MapObj.invalidateSize()

        // DOM操作によるON /OFF
        const shareModal = document.getElementsByClassName('modal')
        if (Array.prototype.find.call(shareModal[0].classList, (el) => el === 'active') === 'active') {
            shareModal[0].className = shareModal[0].className.replace(/active/, 'inactive')
        }
    }

    viewRecentInfoFrame(e) {
        this.setState({ recentInfoView: e })

        // DOM操作によるON /OFF
        const shareModal = document.getElementsByClassName('modal')
        if (Array.prototype.find.call(shareModal[0].classList, (el) => el === 'active') === 'active') {
            shareModal[0].className = shareModal[0].className.replace(/active/, 'inactive')
        }
    }

    viewRecentInfoOnMap() {
        this.setState({markerDatas:this.state.recentDatas})
        this.setState({infoHeaderResult:'新着情報'})
        this.viewInfoFrame(true)
        this.typeBtn.current.updateActiveOption('')
        this.trendBtn.current.updateActiveOption('')
    }

    viewMarkerOnMap(uid) {
        const target = this.state.markerDatas.filter(n => n.uid === uid)
        if (target.length === 1) {
            const position = [target[0].coordinates[0], target[0].coordinates[1]]
            if (this.state.markerDatas.indexOf(target[0]) === 0) {
                MapObj.flyTo(target[0].coordinates, 10)
            } else {
                MapObj.flyTo(position, 10)
            }
        }

        MapObj.eachLayer(function(layer){
            if (typeof layer.options.icon !== 'undefined') {
                console.log({layer})
                if (layer.options.data === uid) {
                    layer.openPopup()
                }
            }
        })
    }

    recentInfoClickHandler(e) {
        const target = ContentClass.lookupByUid(e.target.attributes[0].nodeValue)
        this.viewInfoByUid(target)
    }

    viewInfoByUid(target) {
        this.setState({ selectedData:target.datas }, () => {
            this.viewInfoFrame(true)
        })
        this.setState({ markerDatas:target.datas }, () => {
            this.viewMarkerOnMap(target.datas[0].uid)
        })
        this.typeBtn.current.updateActiveOption('')
        this.trendBtn.current.updateActiveOption('')
    }

    searchBtnClickHandler(e) {
        let kw = document.querySelector(`input[id='sBox']`).value
        this.searchByKeyword(kw)
    }

    searchByKeyword(kw) {
        let temp = ContentClass.urlizeSearchKeywords(decodeURI(kw))
        // document.querySelector(`input[id='sBox']`).value = temp
        const result = ContentClass.normalizeSearchKeywords(temp)
        const target = ContentClass.lookupByKeywords(result)
        if (target.datas.length > 0) {
            this.viewInfoByUid(target)
            this.setState({infoHeaderResult:`「${kw}」を含む事例`})
        }
    }

  render() {
    const position = [35.7010141, 139.7042647]
    const isDeviceBottomSheet = (isMobileOnly || (isTablet && window.innerWidth < 834)) ? true : false
    console.log({isDeviceBottomSheet})
    return (
    <div className="contentFrame">

        <div className="loader" style={this.state.loaderStyle}>
            <Grid
                color="#00BFFF"
                ariaLabel='Loading Datas...'
                height={60}
                width={60}
                timeout={3000} //3 secs
            />
        </div>

        {/* Map View */}
        <MapContainer 
            center={position}
            bounds={[[41.32021987933439, 129.95206767407146],[32.879206348960174, 147.17965585448835]]}
            minZoom={6}
            maxZoom={18}
            scrollWheelZoom={true}
            closePopupOnClick={false}
        >
            <TileLayer
                attribution='<span>&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>｜<a href="https://github.com/stipsan/react-spring-bottom-sheet/blob/main/LICENSE" target="_blank">react-spring-bottom-sheet</a>'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <ZoomControl position="topright" />
            {this.state.prefecture.map((prefecture) =>
                <GeoJSON key='prefecture' data={prefecture} style={this.style} />
            )}
            {this.state.markerDatas.map((data) => {
                let marker
                if (data.type[0] === '5G') {
                    marker = new Icon({
                        iconUrl: marker_5g,
                        iconSize: [18, 26],
                        iconAnchor: [9, 26],
                        shadowUrl: marker_shadow,
                        shadowSize: [27, 39],
                        shadowAnchor: [10, 39],
                        popupAnchor: [0, -36],
                    })
                } else if (data.type[0] === 'L5G') {
                    marker = new Icon({
                        iconUrl: marker_l5g,
                        iconSize: [18, 26],
                        iconAnchor: [9, 26],
                        shadowUrl: marker_shadow,
                        shadowSize: [27, 39],
                        shadowAnchor: [10, 39],
                        popupAnchor: [0, -36],
                    })
                } else if (data.type[0] === 'LAB') {
                    marker = new Icon({
                        iconUrl: marker_lab,
                        iconSize: [18, 26],
                        iconAnchor: [9, 26],
                        shadowUrl: marker_shadow,
                        shadowSize: [27, 39],
                        shadowAnchor: [10, 39],
                        popupAnchor: [0, -36],
                    })
                }
                return (
                    <Marker
                        ref={this.bindMarker}
                        position={data.coordinates}
                        key={data.uid}
                        data={data.uid}
                        icon={marker}
                        eventHandlers={{
                            click: (e) => {
                                this.setState({bottomSheetView:false})
                                const target = ContentClass.lookupByUid(e.target.options.data)
                                this.setState({
                                    selectedData:target.datas
                                }, () => {
                                    this.viewInfoFrame(true)
                                })
                            },
                        }}
                    >
                        <Popup>{data.copy.replace('<br>',' ')}</Popup>
                    </Marker>
                )
            }

            )}
            <MapConsumer>
                {(map) => {
                    MapObj = map
                    map.on('zoomend', function(feature) {
                        const currentZoom = map.getZoom();
                        if (currentZoom >= 10) {
                            feature.target.eachLayer(function(layer) {
                                if (typeof layer.options.icon !== 'undefined') {
                                    layer.options.icon.options.iconSize = [27, 39]
                                    layer.options.icon.options.iconAnchor = [13.5, 39]
                                    layer.options.icon.options.shadowUrl = marker_shadow
                                    layer.options.icon.options.shadowSize = [30, 57]
                                    layer.options.icon.options.shadowAnchor = [10, 57]
                                    layer.options.icon.options.popupAnchor = [0, -44],
                                    layer.setIcon(layer.options.icon)
                                }
                            })
                        } else if  (currentZoom < 10) {
                            feature.target.eachLayer(function(layer) {
                                if (typeof layer.options.icon !== 'undefined') {
                                    layer.options.icon.options.iconSize = [18, 26]
                                    layer.options.icon.options.iconAnchor = [9, 26]
                                    layer.options.icon.options.shadowUrl = marker_shadow
                                    layer.options.icon.options.shadowSize = [27, 39]
                                    layer.options.icon.options.shadowAnchor = [10, 39]
                                    layer.options.icon.options.popupAnchor = [0, -36],
                                    layer.setIcon(layer.options.icon)
                                }
                            })
                        }
                    })
                    return null
                }}
            </MapConsumer>
            {/* <MyComponent /> */}
        </MapContainer>

        <div className={`typeGenreFrame ${this.state[`typeGenreFrameView`]? "active":"inactive"}`} >
            <section className="titleFrame">
                <h1>5G/ローカル5G事例マップ</h1>
                <span className="subTitle">5G / Local 5G Case Study Map</span>
            </section>
            {/* Search Field 
            <section className="searchField">
                <input id="sBox" type="text" placeholder="キーワードを入力" />
                <input id="sBtn" type="submit" value="検索" onClick={this.searchBtnClickHandler} />
            </section> */}
            {/* Type Button */}
            <section className="typeButtons">
                <TypeButton
                    options={['ALL', 'LAB', '5G', 'L5G']}
                    ref={this.typeBtn}
                    onChange={(option) => {
                        let target = []
                        MarkerObj = []
                        this.setState({activeType:option})

                        if (option === 'ALL') {
                            this.setState({infoHeaderResult:'全事例'})
                        } else if (option === 'LAB') {
                            this.setState({infoHeaderResult:'ラボ・開発環境'})
                        } else if (option === '5G') {
                            this.setState({infoHeaderResult:'5G事例'})
                        }
                        
                        if (option === 'L5G') {
                            this.setState({infoHeaderResult:'ローカル5G事例'})
                            this.setState({bottomSheetView:true})

                            if (this.state.activeGenre.length === 0) {
                                this.state.activeGenre = genres

                                genres.forEach((g) => {
                                    genreStatus[g] = true
                                })
                            } else {
                                genres.forEach((g) => {
                                    let status = false
                                    if (this.state.activeGenre.includes(g)) {
                                        status = true
                                    }
                                    genreStatus[g] = status
                                })
                            }
                            target = ContentClass.lookupByGenre(this.state.activeGenre)
                            this.setState({markerDatas:target.datas})

                        } else {
                            target = ContentClass.lookupByType([option])
                            this.setState({markerDatas:target.datas})
                            this.setState({bottomSheetView:false})
                        }

                        if (target.datas.length > 0) {
                            this.viewInfoByUid(target)
                        }
                    }}
                />
            </section>
            {/* Genre Button for PC layout */}
            {!isDeviceBottomSheet &&
                <section className={`genreButtons itsNotForSP ${this.state.activeType === 'L5G' ? 'active' : 'inactive'}`}>
                    <GenreButton
                        options={genres}
                        ref={this.genreBtn}
                        parent={this}
                        parentMethod={this.modifyGenreBtnStatus}
                        onChange={(option) => {
                            let datas = []
                            Object.keys(option).forEach( function(value) {
                                if (this[value] === true) {
                                    datas.push(value)
                                }
                            }, option)

                            this.setState({
                                activeGenre:datas
                            }, () => {
                                this.setState({bottomSheetView:true})
                                const target = ContentClass.lookupByGenre(this.state.activeGenre)
                                this.setState({markerDatas:target.datas})
                            })
                        }}
                    />
                </section>
            }
            {/* Trend Keywords */}
            <section className="trendButtons">
                <span className='heading'>トレンドキーワード</span>
                <TrendButton
                    options={this.state.trendDatas}
                    ref={this.trendBtn} 
                    onChange={(option) => {
                        MarkerObj = []
                        this.searchByKeyword(option.trendWord)
                        this.setState({activeType:''})
                    }} />
            </section>
        </div>

        <div className={`recentInfo ${this.state[`recentInfoView`]? "active":"inactive"}`}>
            <button className="closeTgl" 
                onClick={() => {
                    const recentInfoElem = document.getElementsByClassName('recentInfo')[0]
                    const tgl = recentInfoElem.classList.contains('active') ? false : true
                    this.viewRecentInfoFrame(tgl)
                }}
            >close</button>
             <div className="heading">
                <p>新着情報</p>
             </div>
             <div className="recentInfoFrame">
                <span>{this.state.publishedDate}</span>
            {
                this.state.recentDatas.map((content, idx) => {
                    return (
                        <p key={idx}>
                            <a data-id={content.uid} onClick={this.recentInfoClickHandler}>{content.mainOrg}</a>の情報が追加されました
                        </p>
                    )
                }).filter(content => content)
            }
                <button className="markerBtn"
                    onClick={this.viewRecentInfoOnMap}>新着情報を地図上に表示</button>
            </div>
        </div>

        {isDeviceBottomSheet &&
            <BottomSheet
                open={this.state.bottomSheetView}
                ref={this.bottomSheetRef}
                blocking={false}
                scrollLocking={false}
                defaultSnap={({ lastSnap, snapPoints }) =>
                    lastSnap ?? Math.max(...snapPoints)
                }
                snapPoints={({ maxHeight }) => [
                    maxHeight / 2.0,
                    maxHeight * 0.03,
                ]}
                onSpringStart={(event) => {
                    const reachPortal = document.querySelectorAll('reach-portal > div')[0]
                    const modal = document.querySelectorAll('[data-rsbs-overlay]')[0]
                    let backdrop = document.querySelectorAll('.backdrop')[0]

                    if (event.type === 'CLOSE') {
                        // do nothing
                    } else {
                        if (backdrop) {
                            if (bsRef.current.height < 30) {
                                backdrop.style.display = "block"
                                backdrop.style.opacity = 1
                            } else if (bsRef.current.height > 100) {
                                backdrop.style.opacity = 0
                            }
                        } else {
                            backdrop = document.createElement('div')
                            backdrop.classList.add("backdrop");
                            reachPortal.insertBefore( backdrop, modal);
                        }
                    }
                  }}
                  onSpringEnd={(event) => {
                    const reachPortal = document.querySelectorAll('reach-portal > div')[0]
                    const modal = document.querySelectorAll('[data-rsbs-overlay]')[0]
                    let backdrop = document.querySelectorAll('.backdrop')[0]

                    if (event.type === 'CLOSE') {
                        // do nothing
                    } else {
                        if (backdrop) {
                            if (bsRef.current.height < 100) {
                                backdrop.style.display = "none"
                            } else {
                                backdrop.style.opacity = 1
                            }
                        }
                    }
                  }}
            >
                <section className="genreButtons itsForSP">
                    <GenreButton
                        options={genres}
                        ref={this.genreBtn}
                        parent={this}
                        parentMethod={this.modifyGenreBtnStatus}
                        onChange={(option) => {
                            let datas = []
                            Object.keys(option).forEach( function(value) {
                                if (this[value] === true) {
                                    datas.push(value)
                                }
                            }, option)
                            this.setState({
                                activeGenre:datas
                            }, () => {
                                this.setState({bottomSheetView:true})
                                const target = ContentClass.lookupByGenre(this.state.activeGenre)
                                this.setState({markerDatas:target.datas})
                            })
                        }}
                    />
                </section>
            </BottomSheet>
        }
        
        <div className={`infoFrame ${this.state[`infoFrameView`]? "active":"inactive"}`}>
            <div className="heading"><span>{this.state.infoHeaderResult} ({this.state.infoHeaderNum}件目／全{this.state.markerDatas.length}件)</span>
                <button className="closeBtn" 
                onClick={() => {
                    this.viewInfoFrame(false)
                }}
                >close</button>
            </div>
            {this.state.markerDatas.map((content) =>
                <ContentsView 
                    options={content} 
                    viewMarkerOnMap={this.viewMarkerOnMap}
                    onChange={(idx) => {
                        this.setState({infoHeaderNum:idx})
                    }}
                />
            )}
        </div>
    </div>
    )
  }
}